export function SubscriptionTypeUpgradeCtrl (
  $scope,
  $window,
  $translate,
  sessionObjAPI,
  workshopAPI,
  messages
) {
  $scope.session = sessionObjAPI.base();

  $scope.cancel = function () {
    $window.location.href = '#/dashboard';
  };

  $scope.confirm = function ( tier ) {
    workshopAPI.get('/company/upgrade_workshop_subscription', tier)
    .then(response => {
      if ( response === true ) {
        messages.show( $translate.instant('COMPANY_SPACE.SUBSCRIPTION.SUCCESSFULLY_UPGRADED', {
          tier: tier.toUpperCase()
        }), 'success' );
      }

      $window.location.href = '#/dashboard';
    })
    .catch(err => messages.error(err));
  };

  $scope.getNextTier = () => {
    return !$scope.session.silver_or_higher
      ? 'silver'
      : !$scope.session.gold_or_higher
        ? 'gold'
        : !$scope.session.platinum_or_higher
          ? 'platinum'
          : null;
  };

  $scope.getQuote = function ( newTier ) {
    workshopAPI.get('/company/upgrade_workshop_subscription_quote', newTier)
    .then(quote => $scope.quote = quote)
    .catch(err => messages.error(err));
  };

  $scope.init = function () {
    const nextTier = $scope.getNextTier();

    if ( nextTier ) {
      $scope.getQuote(nextTier);
    }
  };

  $scope.isNextTier = function ( tier ) {
    return tier === $scope.getNextTier();
  };

  $scope.init();
};
